import request from '@/utils/request'

const informationType = {
  name: 'informationType',
  state: {
    isInformationTypeDetailLoading: false,
    informationTypeDetailData: {}
  },

  mutations: {
    SET_IS_MODULES_INFORMATIONTYPE_DETAIL_LOADING: (state, data) => {
      state.isInformationTypeDetailLoading = data
    },
    SET_MODULES_INFORMATIONTYPE_DETAIL_DATA: (state, data) => {
      state.informationTypeDetailData = data
    }
  },

  actions: {
    //  获取账号编辑页面数据
    queryInformationTypeDetailData({ commit }, id) {
      commit('SET_IS_MODULES_INFORMATIONTYPE_DETAIL_LOADING', true)
      commit('SET_MODULES_INFORMATIONTYPE_DETAIL_DATA', {})
      return new Promise((resolve, reject) => {
        request({
          url: '/modules/informationType/informationTypeDetail',
          method: 'post',
          data: { id: id }
        }).then(response => {
          commit('SET_IS_MODULES_INFORMATIONTYPE_DETAIL_LOADING', false)
          commit('SET_MODULES_INFORMATIONTYPE_DETAIL_DATA', response.data)
          resolve(response.data)
        }).catch(error => {
          commit('SET_IS_MODULES_INFORMATIONTYPE_DETAIL_LOADING', false)
          reject(error)
        })
      })
    },
    //  重置账号新增页面数据
    resetInformationTypeDetailData({ commit }) {
      commit('SET_MODULES_INFORMATIONTYPE_DETAIL_DATA', {})
    }
  }
}

export default informationType
